// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "40b338baacb4b033fe0c4a5e4d02593b47b8905c/static/css/" + chunkId + "." + "f83a2947" + ".chunk.css";
};